(function(){
  if(window.__vbBundleInit)return;window.__vbBundleInit=true;

  /* ---- Font prezzi: rossi (nuovi) piu' grandi, confronto (barrati) neri e piu' grandi ---- */
  try{
    var st=document.createElement('style');
    st.textContent=''
      +'.vb-bundle__totals{font-size:19px !important}'
      +'.vb-bundle__totals s{color:#000 !important;font-size:1em !important;font-weight:700 !important;margin-right:6px}'
      +'.vb-bundle__totals strong{color:#7a1f2b !important;font-weight:700 !important;font-size:1.28em !important}'
      +'.vb-bundle__name{font-size:13px !important}'
      +'.vb-bundle__price .vb-old{color:#000 !important;font-size:14px !important;font-weight:700 !important}'
      +'.vb-bundle__price .vb-new{color:#7a1f2b !important;font-weight:700 !important;font-size:17px !important}'
      +'@media (max-width:600px){.vb-bundle__totals{font-size:16px !important}.vb-bundle__price .vb-new{font-size:15px !important}}';
    document.head.appendChild(st);
  }catch(e){}

  /* REGOLA SCONTO:
     - Cinture e portafogli sono SEMPRE scontati, compreso quello della PDP corrente
       (il contenitore ha data-main-discountable="1" quando il prodotto e' un accessorio).
     - La BORSA non e' mai scontata: la sua riga ha data-nodiscount="1".
       Su una PDP borsa il prodotto principale resta a prezzo pieno, come da sempre. */
  function isNoDiscount(input){ return !!(input && input.hasAttribute('data-nodiscount')); }

  function updateVisual(root){
    var accs=[].slice.call(root.querySelectorAll('.vb-acc'));
    var bag=parseInt(root.getAttribute('data-bag'),10)||0;
    var bagCompare=parseInt(root.getAttribute('data-bag-compare'),10)||bag;
    var mainDisc=root.getAttribute('data-main-discountable')==='1';
    var n=0,accBase=0,fullBase=0,accCompare=0;
    accs.forEach(function(a){
      if(a.checked){
        n++;
        var pr=parseInt(a.getAttribute('data-price'),10)||0;
        if(isNoDiscount(a)){fullBase+=pr;}else{accBase+=pr;}
        accCompare+=parseInt(a.getAttribute('data-compare'),10)||0;
      }
      var t=a.getAttribute('data-target');if(t){var img=document.getElementById(t);if(img)img.classList.toggle('vb-off',!a.checked);}
    });
    var disc=n>=2?25:(n===1?15:0);
    [].slice.call(root.querySelectorAll('.vb-new')).forEach(function(el){
      var base=parseInt(el.getAttribute('data-base'),10)||0;
      var rowEl=el.closest('.vb-bundle__row');
      var accInput=rowEl?rowEl.querySelector('.vb-acc'):null;
      var apply=accInput?(!isNoDiscount(accInput)):mainDisc;
      el.textContent=money(apply?Math.round(base*(100-disc)/100):base);
    });
    var mainNow=mainDisc?Math.round(bag*(100-disc)/100):bag;
    var accNow=Math.round(accBase*(100-disc)/100)+fullBase;
    var was=root.querySelector('#vb-was'),now=root.querySelector('#vb-now');
    if(was){was.style.display='';was.textContent=money(bagCompare+accCompare);}
    if(now)now.textContent=money(mainNow+accNow);
    var fill=root.querySelector('#vb-fill'),msg=root.querySelector('#vb-msg');
    if(fill)fill.style.width=(n>=2?100:(n===1?50:8))+'%';
    root.classList.remove('reached1','reached2');if(n>=2)root.classList.add('reached2');else if(n===1)root.classList.add('reached1');
    if(msg){if(n===0){msg.innerHTML='\uD83D\uDC49 Aggiungi 1 prodotto per sbloccare il <b>-15%</b>';}else if(n===1){msg.innerHTML='\u2705 <b>-15% sbloccato!</b> Aggiungine un altro per il <b>-25%</b>';}else{msg.innerHTML='\uD83C\uDF89 <b>-25% sbloccato!</b> Stai risparmiando al massimo';}}
  }

  function takeOver(root){
    [].slice.call(root.querySelectorAll('.vb-acc')).forEach(function(a){
      var clone=a.cloneNode(true);a.parentNode.replaceChild(clone,a);
    });
  }
  function money(c){return '\u20AC'+(c/100).toFixed(2).replace('.',',');}
  function initBundles(){
    [].slice.call(document.querySelectorAll('.vb-bundle')).forEach(function(root){
      if(root.__vbTaken)return;root.__vbTaken=true;root.setAttribute('data-vb-taken','1');
      takeOver(root);
      // Parte con TUTTI gli accessori gia' selezionati (come Portland Leather): immagini a colori, -25% mostrato
      [].slice.call(root.querySelectorAll('.vb-acc')).forEach(function(a){a.checked=true;});
      [].slice.call(root.querySelectorAll('.vb-acc')).forEach(function(a){
        a.addEventListener('change',function(){updateVisual(root);});
      });
      updateVisual(root);
    });
  }

  function collect(root){
    var seen={},items=[];
    [].slice.call(root.querySelectorAll('input[name="items[]"]')).forEach(function(inp){
      var ok=false;
      if(inp.type==='hidden'){ok=true;}
      else if(inp.type==='checkbox'&&inp.checked&&!inp.disabled){ok=true;}
      if(ok){var id=parseInt(inp.value,10);if(id&&!seen[id]){seen[id]=1;items.push({id:id,quantity:1});}}
    });
    return items;
  }
  function restore(btn,label){if(btn){btn.disabled=false;btn.textContent=label||'AGGIUNGI IL SET AL CARRELLO';}}
  function openDrawer(){
    try{
      var t=document.querySelector('[data-armada-selector="cart-toggle"],[data-armada-selector="header-cart-toggle"],[data-cart-toggle],.js-cart-toggle,armada-drawer[data-drawer-id="cart"] [data-drawer-open]');
      if(t){t.click();}
    }catch(e){}
  }
  function xhrJSON(method,url,body){
    return new Promise(function(resolve,reject){
      var x=new XMLHttpRequest();
      x.open(method,url,true);
      x.setRequestHeader('X-Requested-With','XMLHttpRequest');
      if(body)x.setRequestHeader('Content-Type','application/json');
      x.onreadystatechange=function(){
        if(x.readyState!==4)return;
        var data=null;try{data=JSON.parse(x.responseText);}catch(e){}
        if(x.status>=200&&x.status<300){resolve(data);}else{reject(data||{status:x.status});}
      };
      x.onerror=function(){reject({status:x.status});};
      x.send(body?JSON.stringify(body):null);
    });
  }
  function refreshCart(){
    return xhrJSON('GET','/cart.js').then(function(cart){
      try{document.dispatchEvent(new CustomEvent('ARMADA:CART:COUNT:CHANGE',{detail:{count:cart&&cart.item_count}}));}catch(e){}
      try{document.dispatchEvent(new CustomEvent('ARMADA:LOAD:CART',{detail:{}}));}catch(e){}
      return cart;
    });
  }
  function add(root,btn){
    var wanted=collect(root);
    if(!wanted.length)return;
    var label=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='AGGIUNTA IN CORSO...';}
    var done=false;
    var safety=setTimeout(function(){if(!done){restore(btn,label);}},8000);
    function finish(openIt){
      if(done)return;done=true;clearTimeout(safety);
      refreshCart().then(function(){restore(btn,label);if(openIt)openDrawer();},function(){restore(btn,label);if(openIt)openDrawer();});
    }
    xhrJSON('GET','/cart.js').then(function(cart){
      var have={};
      if(cart&&cart.items){cart.items.forEach(function(it){have[it.variant_id]=(have[it.variant_id]||0)+it.quantity;});}
      var toAdd=wanted.filter(function(it){return !have[it.id];});
      if(!toAdd.length){finish(true);return;}
      return xhrJSON('POST','/cart/add.js',{items:toAdd}).then(function(added){
        try{document.dispatchEvent(new CustomEvent('ARMADA:CART:ADD',{detail:{items:(added&&added.items)||toAdd}}));}catch(e){}
        finish(true);
      });
    }).catch(function(err){
      if(done)return;done=true;clearTimeout(safety);
      restore(btn,label);
      alert(err&&err.description?err.description:'Impossibile aggiungere al carrello. Riprova.');
    });
  }

  document.addEventListener('click',function(e){
    var btn=e.target&&e.target.closest?e.target.closest('.vb-bundle__btn'):null;if(!btn)return;
    e.preventDefault();e.stopPropagation();
    var root=btn.closest('.vb-bundle');if(root)add(root,btn);
  },true);
  document.addEventListener('submit',function(e){
    var form=e.target&&e.target.closest?e.target.closest('.vb-bundle__form'):null;if(!form)return;
    e.preventDefault();
  },true);

  function boot(){
    initBundles();
  }
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
  window.addEventListener('load',boot);
  window.addEventListener('pageshow',boot);
  ['page:load','page:loaded','shopify:section:load','turbo:load','turbolinks:load','instantpage:change'].forEach(function(ev){
    document.addEventListener(ev,boot);
  });
  function retryAfterNav(){
    var t=0,iv=setInterval(function(){boot();if(++t>24)clearInterval(iv);},250);
  }
  ['pushState','replaceState'].forEach(function(m){
    var orig=history[m];
    if(typeof orig==='function'){
      history[m]=function(){var r=orig.apply(this,arguments);retryAfterNav();return r;};
    }
  });
  window.addEventListener('popstate',retryAfterNav);
  try{
    var mo=new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        if(muts[i].addedNodes&&muts[i].addedNodes.length){
          var found=document.querySelector('.vb-bundle:not([data-vb-taken])')||document.querySelector('.vb-bundle');
          if(found){initBundles();break;}
        }
      }
    });
    mo.observe(document.documentElement,{childList:true,subtree:true});
  }catch(e){}
  var tries=0,iv=setInterval(function(){initBundles();if(++tries>40)clearInterval(iv);},250);
})();
